export default __webpack_public_path__ + "static/media/enabledSetting.dce7891e.svg";